import TProfileList from './index.vue';

TProfileList.install = app => {
  app.component(TProfileList.name, TProfileList);
};

export default TProfileList;
